import {Link} from 'react-router-dom';
import {useAskStats} from './useAskStats';

export function AskStatsCard() {
  const {
    downloadingAskStatsErrorMsg,
    downloadingAskStatsStatus,
    downloadAskStatsCSV,
  } = useAskStats();
  return (
    <div className="card w-96 bg-base-100 shadow-xl">
      <figure>
        <img
          src="https://www.datocms-assets.com/79195/1705420702-2.png"
          alt="Ask Stats"
        />
      </figure>
      <div className="card-body">
        <h2 className="card-title">Ask Stats (DEPRECATED)</h2>
        <p>Get your Ask CSV extract here</p>
        <div className="card-actions pt-3">
          {downloadingAskStatsStatus === 'none' ? (
            <button className="btn" onClick={downloadAskStatsCSV}>
              Download V1 report
            </button>
          ) : downloadingAskStatsStatus === 'requesting' ? (
            <p className="text-gray-400">Downloading...</p>
          ) : downloadingAskStatsStatus === 'success' ? (
            <p className="text-green-600">Downloaded</p>
          ) : downloadingAskStatsStatus === 'error' ? (
            <p className="text-red-600">Error</p>
          ) : null}
          <Link className="btn btn-primary" to="/reports/ask-stats">
            Go to new report
          </Link>
        </div>
        <div>
          <p>{downloadingAskStatsErrorMsg}</p>
        </div>
      </div>
    </div>
  );
}
